import { fetchGet, fetchPost, jsonToQueryParam } from "./CommonServiceUtils";
import { PNS_SYNC_SERVICE_URL } from "./../Constants";

const getRegionData = (queryObj) =>
  fetchGet(`${PNS_SYNC_SERVICE_URL}regions?${jsonToQueryParam(queryObj)}`);

const getLocations = (queryObj) =>
  fetchGet(`${PNS_SYNC_SERVICE_URL}locations?${jsonToQueryParam(queryObj)}`);

const filterLoyaltyProfileByMobileNumber = (queryObj, payload) =>
  fetchPost(
    `${PNS_SYNC_SERVICE_URL}member/filterbymobile?${jsonToQueryParam(
      queryObj
    )}`,
    payload
  );

const createPortalAccountV2 = (payload) =>
  fetchPost(`${PNS_SYNC_SERVICE_URL}portal/accounts/v2`, payload);

const getAllSriLankanDistricts = () =>
  fetchGet(`${PNS_SYNC_SERVICE_URL}sl/geographics/districts`);

const getAllSriLankanCities = () =>
  fetchGet(`${PNS_SYNC_SERVICE_URL}sl/geographics/cities`);

const getAllSriLankanCitiesByDistrict = (district = "") =>
  fetchGet(`${PNS_SYNC_SERVICE_URL}sl/geographics/cities/${district}`);

const getAllLocations = (params) => {
  return new Promise(async (resolve, reject) => {
    const limit = 500;
    let totalCount = 0,
      locations = [];
    try {
      do {
        const locationsResponse = await getLocations({
          limit,
          skip: locations.length,
          ...params,
        });
        totalCount = locationsResponse.total;
        locations = [...locations, ...locationsResponse.items];
      } while (locations.length < totalCount);

      const enrolLocations = locations
        .filter(
          (location) =>
            !isNaN(Number(location.code)) && // * To temporarily filter out locations without a number for the location code.
            location?.options?.enroll
        )
        .map((eLocation) => ({
          _id: eLocation?._id || "",
          locationName: eLocation?.locationName || "~ unknown",
          locationCode: eLocation?.code || "~ unknown",
        }));

      resolve(enrolLocations);
    } catch (e) {
      reject(e);
    }
  });
};

export {
  filterLoyaltyProfileByMobileNumber,
  getRegionData,
  getAllLocations,
  createPortalAccountV2,
  getAllSriLankanDistricts,
  getAllSriLankanCities,
  getAllSriLankanCitiesByDistrict,
};
